import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { Login } from '../_model/login';
import { AuthService } from '../_services/auth.service';

@Component({
    selector: 'app-password',
    templateUrl: './password.component.html',
    styleUrls: ['./password.component.less'],
    standalone: false
})
export class PasswordComponent implements OnInit {

  constructor(private route: ActivatedRoute, private auth: AuthService) {
    this.route.queryParams.subscribe(params => {
      this.first = params['first'];
    });
  }

  first: boolean = false;
  old: string = "";
  pass: string = "";
  confirm: string = "";
  
  ngOnInit() {
  }

  send(){
    if(this.pass == this.confirm && this.pass != this.old) {
      var model: any = {
        userId: localStorage.getItem("userId"),
        password: this.pass,
        old: this.old
      };
      this.auth.changePassword(model).subscribe(() => {
        Swal.fire({
          title: "<h1 class='textColor harvest-gold base'>Palavra passe actualizada com sucesso</h1>",
          icon: 'success',
          background: '#666666',
          iconColor: "#fff",
          customClass: {
            popup: 'card-border-gold',
            confirmButton: 'btn btn-grad px-8'
          }
        }).then(() => {
          location.href = "/";
        });
        setTimeout(() => {
          location.href = "/";
        },3000);
      }, err => {
        Swal.fire({
          title: "<h1 class='textColor harvest-gold base'>"+err.error+"</h1>",
          icon: 'error',
          background: '#666666',
          iconColor: "#fff",
          customClass: {
            popup: 'card-border-gold',
            confirmButton: 'btn btn-grad px-8'
          }
        });
      });
    }else if(this.pass != this.confirm){
      Swal.fire({
        title: "<h1 class='textColor harvest-gold base'>As palavras passe novas não são iguais</h1>",
        icon: 'error',
        background: '#666666',
        iconColor: "#fff",
        customClass: {
          popup: 'card-border-gold',
          confirmButton: 'btn btn-grad px-8'
        }
      });
    }else if(this.pass == this.old) {
      Swal.fire({
        title: "<h1 class='textColor harvest-gold base'>A palavras passe nova não pode ser igual a palavra-passe antiga</h1>",
        icon: 'error',
        background: '#666666',
        iconColor: "#fff",
        customClass: {
          popup: 'card-border-gold',
          confirmButton: 'btn btn-grad px-8'
        }
      });
    }
  }
}
